import { v4 as uuidv4 } from 'uuid';

// Shared by every caller of startSyncRefresh (useSync.jsx, useSubscriptionDialogs.jsx)
// so the backend-consistency wait only needs tuning in one place.
export const SUBSCRIPTIONS_REFRESH_DELAY_MS = 1000;

// Separate from loadProgress.subscriptions (which defaults to true at boot,
// before any fetch has ever run) — this only ever flips true when the sync
// widget closes, so the blocking overlay it drives can't fire on a page
// that has nothing to do with a just-finished sync.
export function startSyncRefresh() {
    this.loadProgress.syncRefresh = true;
    this.observed.loadProgress = uuidv4();
}

export function stopSyncRefresh() {
    this.loadProgress.syncRefresh = false;
    this.observed.loadProgress = uuidv4();
}

// Shows the overlay, waits, merges in what's new (not a full reset), hides the overlay.
export function refreshSubscriptionsAfterDelay() {
    this.startSyncRefresh();
    clearTimeout(this.pendingRefreshTimer);
    // Captured locally so a later call's timer (scheduled while this one's
    // fetch is still in flight) doesn't get its reference stomped, and so
    // this one doesn't hide the overlay out from under a newer cycle that's
    // still waiting on its own fetch.
    const timer = setTimeout(() => {
        this.mergeLatestSubscription()
            .catch(() => {})
            .finally(() => {
                if (this.pendingRefreshTimer !== timer) return;
                this.pendingRefreshTimer = null;
                this.stopSyncRefresh();
            });
    }, SUBSCRIPTIONS_REFRESH_DELAY_MS);
    this.pendingRefreshTimer = timer;
}

// Cancels a still-pending refreshSubscriptionsAfterDelay timer, if any, so
// an immediate refetch elsewhere (e.g. Remove's refreshSubscriptions() call)
// doesn't race a stale delayed one into a redundant second fetch. Also
// stops the overlay that timer's own startSyncRefresh() already raised —
// otherwise cancelling the timer alone would leave syncRefresh stuck true,
// since the callback that would have cleared it never runs.
export function cancelPendingRefresh() {
    if (!this.pendingRefreshTimer) return;
    clearTimeout(this.pendingRefreshTimer);
    this.pendingRefreshTimer = null;
    this.stopSyncRefresh();
}
